import { CreditCardIcon } from "lucide-react";

export function CardBrandMark({ brand }: { brand: string }) {
  const normalizedBrand = brand.toLowerCase();

  return (
    <span className="flex h-10 w-14.5 shrink-0 items-center justify-center rounded-md border border-border-secondary bg-bg-primary p-xs">
      {normalizedBrand === "visa" && <VisaMark />}
      {normalizedBrand === "mastercard" && <MastercardMark />}
      {normalizedBrand !== "visa" && normalizedBrand !== "mastercard" && (
        <CreditCardIcon className="h-full w-full text-text-tertiary" />
      )}
    </span>
  );
}

function MastercardMark() {
  return (
    <svg
      aria-hidden="true"
      className="h-full w-full"
      fill="none"
      viewBox="0 0 48 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="19" cy="16" fill="#EB001B" r="10" />
      <circle cx="29" cy="16" fill="#F79E1B" r="10" />
      <path
        d="M24 7.34a10 10 0 0 1 0 17.32 10 10 0 0 1 0-17.32Z"
        fill="#FF5F00"
      />
    </svg>
  );
}

function VisaMark() {
  return (
    <svg
      aria-hidden="true"
      className="h-full w-full"
      fill="none"
      viewBox="0 0 48 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <text
        fill="#1A1F71"
        fontFamily="Arial, Helvetica, sans-serif"
        fontSize="15"
        fontStyle="italic"
        fontWeight="bold"
        letterSpacing="-0.5"
        textAnchor="middle"
        x="24"
        y="21"
      >
        VISA
      </text>
    </svg>
  );
}
